// import { BrowserRouter as Router, Routes, Route, Outlet  } from "react-router-dom";
// import './App.css';
// import LoginScreen from "./pages/login-screen/LoginScreen";
// import ForgotPassword from "./pages/forgot-password/ForgotPassword";
// import DashboardPage from "./pages/dashboard/Dashboard";
// import Appointments from "./pages/appointments/Appointments";
// import PharamacyInventory from "./pages/pharamacy-Inventory/PharamacyInventory";
// import UploadDocuments from "./pages/upload-documents/UploadDocuments";
// import DocumentsUnderProcess from "./pages/document-under-process/DocumentsUnderProcess";
// import UploadRequiredDocuments from "./pages/upload-required-documents/UploadRequiredDocuments";
// import Header from "./components/header/Header";
// import Patients from "./pages/patients/Patients";
// import PatientsProfile from "./pages/patients-profile/PatientsProfile";
// import PatientRegistration from "./pages/patient-registration/PatientRegistration";
// import Wallet from "./pages/wallet/Wallet";
// import WithdrawFromWallet from "./pages/withdraw-from-wallet/WithdrawFromWallet";
// import MyProfile from "./pages/my-profile/MyProfile";
// import { useTranslation } from "react-i18next";
// import Introduction from "./pages/introduction/Introduction";
// import "./i18n";
// import Setting from "./pages/setting/Setting";
// import Faqs from "./pages/faqs/faq";
// import DoctorSupport from "./pages/doctor-support/DoctorSupport";
// import Chat from "./pages/chat/Chat";
// import PharmacyDashboard from "./pages/Pharmacy-Dashboard/PharmacyDashboard";
// import PharmacyAllOrder from "./pages/Pharmacy-All-Order/PharmacyAllOrder";
// import PharmacyOrdersRequest from "./pages/pharmacy-orders-request/PharmacyOrdersRequest";
// import PharmacyOrdersHistory from "./pages/pharmacy-orders-history/PharmacyOrdersHistory";
// import OrderDetails from "./pages/PharmacyOrderDetails/OrderDetails";
// import PharmacyManageProduct from "./pages/pharmacy-add-medicine-to-inventory/PharmacyAddMedicineToInventory";
// import PharmacyEditManageProduct from "./pages/pharmacy-edit-manage-product/PharmacyEditManageProduct";
// import PharmacyAddMedicineToInventory from "./pages/pharmacy-add-medicine-to-inventory/PharmacyAddMedicineToInventory";
// import ResetPassword from "./pages/reset-password/ResetPassword";
// import UploadDocumentsPharma from "./pages/pharmacy-upload-document/UploadDocumentsPharma";
// import DoctorCalendar from "./pages/calender/DoctorCalendar";

// function LayoutWithHeader({changeLanguage}) {
//   return (
//     <>
//       <Header changeLanguage={changeLanguage}/>
//       <Outlet /> {/* renders child routes */}
//     </>
//   );
// }

// function App() {
//    const { t, i18n } = useTranslation();

//   const changeLanguage = (lang) => {
//     i18n.changeLanguage(lang);
//    document.dir = (lang === "ar" || lang === "ku") ? "rtl" : "ltr";
//   };

//   return (
//     <div className="App">
//     <Router>
//            <Routes>
//              {/* No header */}
//              <Route path="/dashboard" element={<DashboardPage />} />
//              <Route path="/appointments" element={<Appointments />} />
//              <Route path="/appointments-calender" element={<DoctorCalendar />} />
//              <Route path="/documents-under-process" element={<DocumentsUnderProcess />} />
//              <Route path="/patients" element={<Patients />} />
//              <Route path="/patients-profile" element={<PatientsProfile />} />
//              <Route path="/patient-registration" element={<PatientRegistration />} />
//              <Route path="/wallet" element={<Wallet />} />
//              <Route path="/withdraw-from-wallet" element={<WithdrawFromWallet />} />
//              <Route path="/my-profile" element={<MyProfile />} />
//              <Route path="/setting" element={<Setting />} />
//              <Route path="/help-and-support" element={<Faqs />} />
//              <Route path="/chat" element={<Chat />} />
//              <Route path="/doctor-support" element={<DoctorSupport />} />

//              {/* With header */}
//              <Route element={<LayoutWithHeader changeLanguage={changeLanguage}/>}>
//                <Route path="/" element={<LoginScreen />} />
//                <Route path="/introduction" element={<Introduction />} />
//                <Route path="/upload-required-documents" element={<UploadRequiredDocuments />} />
//                <Route path="/upload-documents" element={<UploadDocuments />} />
//                <Route path="/forgot-password" element={<ForgotPassword />} />
//                <Route path="/reset-password" element={<ResetPassword />} />

//              </Route>

//             {/* <Route path="/pharmacy-upload-required-documents" element={<UploadRequiredDocuments />} /> */}
//               <Route path="/pharmacy-upload-documents" element={<UploadDocumentsPharma />} />
//             <Route path="/pharmacy-dashboard" element={<PharmacyDashboard />} />
//             <Route path="/pharmacy-all-order" element={<PharmacyAllOrder />} />
//             <Route path="/pharmacy-orders-request" element={<PharmacyOrdersRequest />} />
//             {/* <Route path="/pharmacy-orders-history" element={<PharmacyOrdersHistory />} />  */}
//             <Route path="/pharmacy-orders-history" element={<PharmacyOrdersHistory />} />
//             <Route path="/pharmacy-order-details" element={<OrderDetails />} />
//             <Route path="/ducts" element={<PharamacyInventory />} />
//             <Route path="/pharmacy-manage-product" element={<PharmacyEditManageProduct />} />
//             <Route path="/pharmacy-add-medicine-to-inventory" element={<PharmacyAddMedicineToInventory />} />

//            </Routes>
//          </Router>
//     </div>
//   );
// }

// export default App;

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import "./App.css";
import Header from "./components/header/Header";
import { useTranslation } from "react-i18next";
import "./i18n";
import SessionManager from "./components/session-manager/SessionManager";
import ProtectedRoute from "./components/route-protection/ProtectedRoute";
import { useEffect } from "react";

// lab module imports
import LabLogin from "./pages/lab-module/login-screen/LoginScreen";
import LabForgotPass from "./pages/lab-module/forgot-password/ForgotPassword";
import ForgotPassword from "./pages/forgot-password/ForgotPassword";
import LabResetPass from "./pages/lab-module/reset-password/ResetPassword";
import LabDashboard from "./pages/lab-module/dashboard/Dashboard";
import LabOrderManagement from "./pages/lab-module/lab-order-management/LabOrderManagement";
import LabSetting from "./pages/lab-module/setting/Setting";
import LabChangePassword from "./pages/lab-module/change-password/ChangePassword";
import LabChat from "./pages/lab-module/chat/LabChat";
import LabChatList from "./pages/lab-module/chat-list/ChatList";
import LabProfile from "./pages/lab-module/lab-profile/LabProfile";
import LabOnboarding from "./pages/lab-module/lab-onboarding/LabOnboarding";
import LabServicesAndPricing from "./pages/lab-module/services-pricing/ServicesAndPricing";
import LabEarningPayment from "./pages/lab-module/earning-payment/LabEarningPayment";
import LabTechnicianManagement from "./pages/lab-module/technician-management/TechnicianManagement";
import LabAppointmentDetail from "./pages/lab-module/lab-appointment-detail/lab_appointment_detail";
import LabReportManagement from "./pages/lab-module/lab-report-management/LabReportManagement";
import LabManagementPatientAppointmentDetail from "./pages/lab-module/lab-management-patient-appointment-detail/lab_management_patient_appointment_detail";
import PublicAppointmentDetail from "./pages/lab-module/public-appointment-detail/PublicAppointmentDetail";
import LabWithdrawFromWallet from "./pages/lab-module/withdraw-from-wallet/WithdrawFromWallet";
import AccountDeactivatedModal from "./components/account-deactivated/AccountDeactivatedModal";

function LayoutWithHeader({ changeLanguage }) {
  return (
    <>
      <Header changeLanguage={changeLanguage} />
      <Outlet />
    </>
  );
}

function App() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.dir = lang === "ar" ? "rtl" : "ltr";
  };

  // Set initial direction based on current language
  useEffect(() => {
    document.dir = i18n.language === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  return (
    <SessionManager>
      <div className="App">
        <Router>
          <Routes>
            {/* Public routes - No authentication required */}
            <Route
              element={<LayoutWithHeader changeLanguage={changeLanguage} />}
            >
              <Route path="/" element={<LabLogin />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/lab_forgot" element={<LabForgotPass />} />
              <Route path="/lab_reset" element={<LabResetPass />} />
            </Route>

            {/* Public appointment detail - No authentication required */}
            <Route
              path="/public/appointment/:id"
              element={<PublicAppointmentDetail />}
            />

            {/* Protected Lab routes (role_id: 9) */}
            <Route
              path="/lab_dashboard"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_ordermanagement"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabOrderManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_setting"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabSetting />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_change_password"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_chat"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabChat />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_chatlist"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabChatList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_onboarding"
              element={
                <ProtectedRoute
                  allowedRoleId={9}
                  redirectTo="/"
                  requireOnboarding={false}
                >
                  <LabOnboarding />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_profile"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_services"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabServicesAndPricing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_earning_payment"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabEarningPayment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_technicianmanagement"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabTechnicianManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_appointment_detail/:id"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabAppointmentDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_report-management"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabReportManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_Report_management_patient_appoitment_details/:id"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabManagementPatientAppointmentDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab_withdraw_from_wallet"
              element={
                <ProtectedRoute allowedRoleId={9} redirectTo="/">
                  <LabWithdrawFromWallet />
                </ProtectedRoute>
              }
            />
          </Routes>
          <AccountDeactivatedModal />
        </Router>
      </div>
    </SessionManager>
  );
}

export default App;
